import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChannelHierarchyComponent } from './channel-hierarchy/channel-hierarchy.component';
import { SharedModule } from '../../core/shared/shared.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from '../../../app/app-translate-loader';
import { CommonComponentsModule } from "../../common/common-components.module";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpartanModule } from 'src/app/spartan/spartan.module';


@NgModule({
  declarations: [ChannelHierarchyComponent],
  imports: [
    CommonModule,
    SharedModule,
    SpartanModule,
    MatProgressSpinnerModule,
    TranslateModule.forRoot({
        defaultLanguage: 'es',
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
    CommonComponentsModule
],
  exports: [ChannelHierarchyComponent],
})
export class ChannelHierarchyModule {}
